export const GET_RESIT_REGISTER_OPTIONS = 'user-modules';

export const POST_CANDIDATE_SEARCH = '/candidate';
export const GET_WINDOW_PERIOD = '/time-windows/resit';
export const GET_TEMPLATE_DOWNLOAD_URL = '/download';
export const GET_PRE_SIGN_UPLOAD_URL = '/upload';
export const POST_VALIDATE_UPLOAD_FILE = '/validate';
export const POST_SET_FILE_STATUS_UPLOADED = '/document/api/s3/upload/scan/';
export const GET_UPLOAD_FILE_SCAN_STATUS = '/candidate/api/resit/check-status';
export const POST_SUBJECT_SUMMARY = '/subject-summary';
export const POST_RESIT_GROUP_FEE = '/registration/group/fees';
export const POST_RESIT_CANDIDATE_GROUP_FEE_SAVING = '/group-registration/candidate/save';

export const GET_RESIT_SIMPLIFIED_PAYMENT_DETAIL = (internalTransactionRef: string) =>
    `/transaction-info/${internalTransactionRef}`;
export const POST_RESIT_COORDINATOR_DOWNLOAD_SUMMARY = `/coordinator/receipts`;
export const GET_RESIT_COORDINATOR_ACCESS = (examCode: string) => `/access/${examCode}`;

// for coordinator send bulk email
export const GET_RESIT_APPLICATION_STATUS = (id: string) => `/registrations/${id}`;
export const GET_RESIT_APPLICATION_DOWNLOAD_SUMMARY = `/coordinator/application-pdf`;

export const GET_RESIT_CONFIGURATION = `/registration/configuration`;
